import { Component, EventEmitter, Input, Output } from '@angular/core';
import { filterColors } from './filters';

@Component({
  selector: 'api-collection',
  templateUrl: './api-collection.component.html',
  standalone: false,
})
export class ApiCollectionComponent {
  @Input() apis: any;
  @Input() data: any;
  filterColors = filterColors;
  @Input() filtersSummary: any;
  constructor() {}

  trackByProductIdentity(index: number, product: any): string {
    return (product.productTitle || '') + '|' + (product.productTo || index);
  }

  splitRegions(region?: string): string[] {
    return region
      ? region
          .split(',')
          .map((r) => r.trim())
          .filter(Boolean)
      : [];
  }

  countryIconName(country: string): string {
    return country.toLowerCase().replace(/\s+/g, '-');
  }
}
